import * as React from "react";
import {cx} from "emotion";

import "./calculate-form.scss";

import {bindInput}              from "@Common/react/bind-input";
import {cs}                     from "@Common/react/chain-services";
import {Form2}                  from "@Common/react/cs-form-2/form2";
import {required}               from "@Common/react/cs-form-2/validators/required";
import {keyed}                  from "@Common/react/keyed";
import {onChangeState}          from "@Common/react/on-change-state";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {UseState}               from "@Common/react/use-state";
import {Checkbox}               from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {isSpecialKey}           from "@Common/utils/browser/is-special-key";

export const CalculateForm = (
    {
        formFields,
        pending, calculated, onSubmit,
        disabled
    }
) => cs(
    ["submitError", (_, next) => UseState({
        next,
    })],
    ["data", ({submitError}, next) => next(onChangeState({
        state: pending,
        onChange: () => submitError.value && submitError.onChange(null),
    }))],
    ["form", ({fields, data}, next) => Form2({
        data,
        fields: formFields?.map((field) => ({
            path: [field.path],
            validators: field.bypassField && data.value?.[field.bypassField] ? [] : [required],
        })),
        next,
    })],
    ({submitError, data, form: form1}) => {
        const renderField = (field, {disabled=false, inputProps=undefined, xdQaName=undefined}={}) => <>
            <div className="input">
                <input {...{
                    ...bindInput(field.state),
                    "xd-qa-type": "text_field",
                    "xd-qa-name": xdQaName + " Input",
                    disabled,
                    className: cx({hasError: field.error}),
                    ...inputProps,
                }}/>

                {field.error && (
                    <div className="error" xd-qa-type="label" xd-qa-name="Required">
                        Required
                    </div>
                )}
            </div>
        </>;

        return (
            <div className="calculate-form calculate-form-0p5">
                {formFields?.map((field, i) => cs(
                    keyed(i),
                    () => (
                        <div className={cx("line", {bypass: field.bypassField})}>
                            <div className="left" xd-qa-type="label" xd-qa-name={field.label}>
                                {field.label}
                            </div>
                            <div className="right">
                                {renderField(form1.field(field.path), {
                                    disabled: data.value?.[field.bypassField],
                                    inputProps: field.rejectKey && {
                                        onKeyDown: (e) => {
                                            if (isSpecialKey(e) || e.key?.length > 1) {

                                            } else if (field.rejectKey(e.key)) {
                                                e.preventDefault();
                                            }
                                        },
                                    },
                                    xdQaName: field.label,
                                })}

                                {field.bypassField && (
                                    <div
                                        className="checkbox"
                                        onClick={() => stateChangeNestedValue(data, [field.bypassField], v => !v)}
                                    >
                                        {Checkbox({
                                            checked: data.value?.[field.bypassField],
                                            xdQaName: field.bypassLabel + " checkbox",
                                        })}

                                        <div className="text" xd-qa-type="label" xd-qa-name={field.bypassLabel}>
                                            {field.bypassLabel}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                ))}

                {submitError.value && (
                    <div className="line error">
                        <div className="left"/>
                        <div className="right" xd-qa-type="label" xd-qa-name={submitError.value.msg}>
                            {submitError.value.msg}
                        </div>
                    </div>
                )}

                <div className="line calculate">
                    <div className="left"/>
                    <div className="right">
                        <button
                            onClick={() => form1.submit({
                                onSubmit: async () => {
                                    try {
                                        await onSubmit();
                                    } catch (e) {
                                        submitError.onChange(e);
                                    }
                                },
                            })}
                            className={cx({disabled: !form1.valid})}
                            disabled={form1.submitting || disabled}
                            xd-qa-type="button"
                            xd-qa-name="CALCULATE CO-PAY"
                        >
                            {!calculated ? (
                                form1.submitting ? (
                                    "CALCULATING..."
                                ) : (
                                    "CALCULATE CO-PAY"
                                )
                            ) : (
                                form1.submitting ? (
                                    "RECALCULATING..."
                                ) : (
                                    "RECALCULATE CO-PAY"
                                )
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    },
);
